export const formateCoctailPayload = (values: any) => {
  const engData = {};
  const ruData = {};
  const otherData = {};


  for (const key in values) {
    if (key.startsWith('eng')) {
      const newKey = key.substring(4);
      engData[newKey] = values[key];
    } else if (key.startsWith('ru')) {
      const newKey = key.substring(3);
      ruData[newKey] = values[key];
    } else {
      otherData[key] = values[key];
    }
  }

  return { ...otherData, eng: engData, ru: ruData };
};
